import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { ExamePrintClient } from "@/client/modules/atendimento/exame/detalhe/exame-print-client";

export const Route = createFileRoute("/app/atendimento/exame/$id")({
  loader: ({ context, params }) =>
    ensurePage(context.queryClient, apiQuery("atendimento", "examePage", { id: params.id })),
  head: () => pageHead("Solicitação de exame"),
  component: PrintPage,
});

function PrintPage() {
  const { id } = Route.useParams();
  const { data } = useApiSuspenseQuery("atendimento", "examePage", { id });
  return <ExamePrintClient exam={data} />;
}
